<template>
  <div class="pl-gradient-btn" @click="handleClick" :style="btnStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PlGradientBtn',
  props: {
    firstColor: {
      type: String,
      default: '#ffad37'
    },
    secondColor: {
      type: String,
      default: '#ff8008'
    },
    rotateDeg: {
      type: String,
      default: '120deg'
    },
    type: {
      type: String,
      default: 'default'
    },
    width: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    background () {
      if (this.type === 'default') {
        return `background:${this.firstColor};background-image:linear-gradient(${this.rotateDeg}, ${this.firstColor}, ${this.secondColor})`
      } else if (this.type === 'plain') {
        return `border:1px solid transparent;color:${this.secondColor};box-shadow: 0 0 1px 1px ${this.secondColor};`
      } else {
        return ''
      }
    },
    btnStyle () {
      if (this.width) {
        return `width:${this.width};${this.background}`
      } else {
        return this.background
      }
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="scss" scoped>
.pl-gradient-btn {
  width: 141px;
  height: 35px;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  line-height: 35px;
  text-align: center;
  border-radius: 18px;
}
@media screen and (orientation: landscape) {
  .pl-gradient-btn {
    width: 130px;
  }
}
</style>
